import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import {
  IndirectTaxProductResponse,
  UseIndirectTaxProductParams,
} from './types';

export function useIndirectTaxProduct({
  token,
  productId,
  corporationId,
}: UseIndirectTaxProductParams) {
  const { data, mutate, error, isLoading } = useSWR<IndirectTaxProductResponse>(
    productId && corporationId
      ? `new-sales-tax/products/${productId}/corporation/${corporationId}`
      : null,
    SWRFetcher({ method: 'GET' }, token)
  );

  return {
    product: data?.data ?? null,
    mutate,
    error,
    isLoading,
  };
}
